module.exports = __webpack_public_path__ + "static/media/micro-3.410c1595.svg";